import { __decorate } from "tslib";
import { customElement, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { CellTemplate as template } from './cell.template';
/**
 * The Grid Pro Cell element.
 * @remarks Used inside the Grid Pro Column element, to define a cell renderer from the template.
 * @public
 */
let GridProCell = class GridProCell extends FoundationElement {
    connectedCallback() {
        super.connectedCallback();
        const wrapperGridProColumn = this.parentElement;
        if (this.renderer) {
            wrapperGridProColumn.definition.cellRenderer = this.renderer;
        }
        if (this.rendererParams) {
            wrapperGridProColumn.definition.cellRendererParams = this.rendererParams;
        }
    }
    init(params) {
        this.rendererParams = params;
    }
    getGui() {
        if (typeof this.renderer !== 'string') {
            return this.renderer(this.rendererParams);
        }
        return this;
    }
    destroy() { }
    refresh(params) {
        return false;
    }
    slottedAgRendererChanged() { }
};
__decorate([
    observable
], GridProCell.prototype, "renderer", void 0);
__decorate([
    observable
], GridProCell.prototype, "rendererParams", void 0);
__decorate([
    observable
], GridProCell.prototype, "slottedRenderer", void 0);
GridProCell = __decorate([
    customElement({
        name: 'grid-pro-cell',
        template,
    })
], GridProCell);
export { GridProCell };
